
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import {
  CheckCircleIcon,
  DocumentCheckIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import { FaceFrownIcon } from "@heroicons/react/20/solid";
import Layout from "../Layout";
import Header from "../components-layout/Header";
import WarningModal from "../components-modals/WarningModal";
import Container from "../components-layout/Container";
import ResultadoDataGrid from "../tools/CustomDataGrid";
import { Transition } from "@headlessui/react";
import { columns } from "./models/columns-stats.config";
import Calendar from "./components/Calendar";
import { useSedes } from "./hooks/useCampus";
import { useNiveles } from "./hooks/useNiveles";
import { useGrados } from "./hooks/useGrados";
import { useSecciones } from "./hooks/useSecciones";
import { reportes } from "./services/asistenciaReportes.service";
import { daysInMonth } from "./utils/calendar.utils";
import { formatearFechaDiagonalesDDMMYY } from "../tools/ConversionFechas";
import ComboDato from "./components/ComboDato";
import { ComboMeses, TipoVista } from "./components/comboMeses";
import { classNames } from "../tools/ClassNames";
import { callCiclo } from "../asignacion-horario/services/Asignacion.service";

const VistaAsistenciaIndex = () => {
  const IdEmp = useSelector((state) => state.auth.IdEmp);
  const user = useSelector((state) => state.auth.user);
  const sede = useSelector((state) => state.auth.IdSede);
  const userObj = JSON.parse(user);
  const sedesRef = useRef(null);
  userObj.LoginId = userObj.LoginId.split(" ")
  .map((x) => {
      return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
    })
    .join(" ");
  const [idSede, setIdSede] = useState("");
  const [idNivel, setIdNivel] = useState("");
  const [idGrado, setIdGrado] = useState("");
  const [idSeccion, setIdSeccion] = useState("");
  const [tipoReporte, setTipoReporte] = useState("0")
  const [idMes, setIdMes] = useState(0)
  const [nombreMes, setNombreMes] = useState("")
  const [listaFaltas , setListaFaltas] = useState([])
  const [month, setMonth] = useState(1)
  const [year, setYear] = useState(2024)
  const [subtituloTipos, setSubtituloTipos] = useState("");
  const [loading, setLoading] = useState(false);
  const [reporteDatos, setReporteDatos] = useState()
  const searchParams = ["Carnet", "NombreCompleto"];
  const cookies = new Cookies();
  //const url = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies
  const urlState = useSelector(state => state.url.urlSchoolApi)
  const url = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlSchoolApi") : urlState
  const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux
  //Manejo de errores
  const [modal, setModal] = useState({
    show: false,
    msg: "",
    ok: false,
  });

  const [modalSeguro, setModalSeguro] = useState({
    show: false,
    msg: "",
  });
  const [ciclo, setCiclo] = useState(2024);
  const [sedes] = useSedes([])
  const [niveles, setNiveles] = useNiveles([], idSede);
  const [secciones, setSecciones] = useSecciones([], idSede, idGrado)
  const [grados, setGrados ] = useGrados([], idSede, idNivel);
  const [fechaInicial, setFechaInicial] = useState("")
  const [fechaFinal, setFechaFinal] = useState("")
  const [datosTipos, setDatosTipos] = useState([]);
  const [controlesBloqueados, setControlesBloqueados] = useState(false);
  const [indiceDia, setIndiceDia] = useState(""); // necesario para que se actualice el boton de estadistica
  const [filterData, setFilter] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 100; // observacion, al eliminar elementos, no se aconseja la paginacion
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filterData?.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  
  const [stats, setStats] = useState([
    {
      name: "Pendientes",
      stat: 0,
      color: "text-gray-500",
      comando: "Todos",
    },
    {
      name: "Presentes",
      stat: 0,
      color: "text-green-500",
      comando: "Presente",
    },
    {
      name: "Ausentes",
      stat: 0,
      color: "text-red-500",
      comando: "Ausente",
    },
    { name: "Tarde", stat: 0, color: "text-yellow-500", comando: "Tarde" },
  ]);

  const columnas = columns;
  
  useEffect(() => {
    if(tipoReporte === "1"){
      setStats([
        {
          name: "Faltas",
          stat: "F",
          bgColor: "red-500",
          comando: "Todos",
          number: getFaltas("F", listaFaltas, indiceDia)
        },
        {
          name: "Llegadas tarde",
          stat: "T",
          bgColor: "yellow-400",
          comando: "Ausente",
          number: getFaltas("T", listaFaltas, indiceDia)
        },
      ]);
    }else{
      setStats([
        {
          name: "Faltas",
          stat: <FaceFrownIcon className={`h-6 w-6 text-red-500`}/>,
          bgColor: "red-500",
          comando: "Todos",
        },
        {
          name: "Llegadas tarde",
          stat: <FaceFrownIcon className={`h-6 w-6 text-yellow-400`}/>,
          bgColor: "yellow-400",
          comando: "Ausente", 
        },
        {
          name: "Pendiente",
          stat: <FaceFrownIcon className={`h-6 w-6 text-gray-400`}/>,
          bgColor: "gray-400",
          comando: "Ausente",
        },
      ]);
    }
  }, [listaFaltas])
  
  useEffect(() => {
    if(tipoReporte === "1"){
      setStats([
        {
          name: "Faltas",
          stat: "F",
          bgColor: "red-500",
          comando: "Todos",
          number: 0
        },
        {
          name: "Llegadas tarde",
          stat: "T",
          bgColor: "yellow-400",
          comando: "Ausente",
          number: 0
        },
      ]);
    }else{
      setStats([
        {
          name: "Faltas",
          stat: <FaceFrownIcon className={`h-6 w-6 text-red-500`}/>,
          bgColor: "red-500",
          comando: "Todos",
          number: getEstados('NoVino', indiceDia)
        },
        {
          name: "Llegadas tarde",
          stat: <FaceFrownIcon className={`h-6 w-6 text-yellow-400`}/>,
          bgColor: "yellow-400",
          comando: "Ausente", 
          number: getEstados('Tarde', indiceDia)
        },
        {
          name: "Pendiente",
          stat: <FaceFrownIcon className={`h-6 w-6 text-gray-400`}/>,
          bgColor: "gray-400",
          comando: "Ausente",
          number: getEstados('Pendiente', indiceDia)
        },
      ]);
    }
  }, [reporteDatos])

  const getEstados = (parametro, indiceDia) => {
    let numero = []
    if(reporteDatos?.length > 0 ){
      Object.values(reporteDatos).forEach(e => {
        e[parametro] && numero.push(e[parametro])
      })
    }
    return numero.length
  }
  

  
  userObj.LoginId = userObj.LoginId.split(" ")
    .map((x) => {
      return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
    })
    .join(" ");
  
  const handleAlumnoCta = (alumno, text) => {
   
  }

  const verModalSeguro = (info, infoFecha, estado) => {
    setModalSeguro({
      show: true,
      title:info.Carnet,
      msg:`${info.Alumno} ${estado === 'F' ? "Faltó" : "LLegó tarde"} en la fecha ${formatearFechaDiagonalesDDMMYY(infoFecha.date)}`
    })
  }

  const handleSede = (e) => {
    // combo para obtrener los values de los combos
    setNiveles([]);
    setGrados([]);
    setSecciones([]);
    setIdSede(e.target.value);
    setIdNivel("")
    setIdGrado("")
    setIdSeccion("");
  };

  useEffect(() => {
    setReporteDatos([])
    setListaFaltas([])
    setIndiceDia("")
  }, [idSede, idMes, idNivel, idGrado, idSeccion])


  useEffect(() => {
    setListaFaltas([])
    setDatosTipos([])
  }, [tipoReporte])
  

  const handleNivel = (e) => {
    setGrados([]);
    setSecciones([]);
    setIdNivel(e.target.value);
    setIdGrado("")
    setIdSeccion("");
  };

  const handleGrado = (e) => {
    setSecciones([]);
    setIdNivel(e.target.value);
    setIdGrado(e.target.value);
    setIdSeccion("");
  };

  const handleSeccion = (e) => {
    setIdSeccion(e.target.value);
  };

  const getCiclo = async () => {
    const ciclo = await callCiclo(url, headers)
    setCiclo(ciclo)
  }
  
  useEffect(() => {
    setMonth(new Date().getMonth() + 1)
    setYear(new Date().getFullYear())
    getCiclo()
  }, []);

  const getFaltas = (letra, faltasParam, indiceDia) => {
    let faltas = []
    Object.values(faltasParam).forEach(e => {
      if(e[`D${indiceDia}`] === letra){
        faltas.push(letra)
      }
    })
     return faltas.length
  }
  useEffect(() => {
    setNiveles([]);
    setGrados([]);
    setSecciones([]);
    setIdSeccion("");
    setStats([
      {
        name: "Faltas",
        stat: "F",
        bgColor: "red-500",
        comando: "Todos",
        number: 0
      },
      {
        name: "Llegadas tarde",
        stat: "T",
        bgColor: "yellow-400",
        comando: "Ausente",
        number: 0
      },
    ]);
  }, [idSede])

  useEffect(() => {
    setIdSede(sede);
    sedesRef.current.value = sede;
  }, [sedes]);

  useEffect(() => {
    setFilter(datosTipos);
  }, [datosTipos]);

  const handleQuery = (values) => {
    doSearch(values.query.trim());
    setCurrentPage(1);
  };

  const doSearch = (query) => {
    if (query === null) {
      setFilter(datosTipos);
    } else {
      setFilter(
        datosTipos.filter((x) => {
          return searchParams.some((y) => {
            return (
              x[y]?.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        })
      );
    }
  };

  const nPages = Math.ceil(filterData?.length / recordsPerPage);
  const obtenerReporte = async () => {
    let comprobador = false
    if(tipoReporte === "1"){
      comprobador = idSede && idMes && idNivel && idGrado && idSeccion
    }else{
      comprobador = idSede && idNivel && idGrado && idSeccion && fechaFinal && fechaInicial
    }
    if(comprobador) {
        setIndiceDia(0)
        setLoading(true)
        setListaFaltas([])
        setReporteDatos([])
        let mesStr = idMes.toString().padStart(2,'0')
        let diasMes = daysInMonth(mesStr, ciclo)
    
        const objetoDetalle = {
            "IdCiclo": ciclo,
            "IdSede": idSede.toString(),
            "IdGrado": idGrado.toString(),
            "IdSeccion": idSeccion.toString(),
            "Detalle": parseInt(tipoReporte),
            "Mes": idMes
        }
    
        const objetoResumen = {
            "IdCiclo": ciclo,
            "IdSede": idSede.toString(),
            "IdGrado": idGrado.toString(),
            "IdSeccion": idSeccion.toString(),
            "Detalle": parseInt(tipoReporte),
            "Desde": fechaInicial.replaceAll("-",""),
            "Hasta": fechaFinal.replaceAll("-", ""),
        }
        
        const objetoEnvio = tipoReporte === "1" ? objetoDetalle: objetoResumen
        try {
            const data = await reportes(url, headers, objetoEnvio)
            setReporteDatos(data.msg);
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setModal({
              show:true,
              ok:false,
              msg: "No se pudo obtener la información",
            })
        }
    }else{
        setModal({
          ok:false,
          show:true,
          msg: "Ingrese todos los datos de búsqueda"
        })
    }
  }

  const handleMesChange = (e) => {
    let meses = {
      1:"Enero",
      2:"Febrero",
      3:"Marzo",
      4:"Abril",
      5:"Mayo",
      6:"Junio",
      7:"Julio",
      8:"Agosto",
      9:"Septiembre",
      10:"Octubre",
      11:"Noviembre",
      12:"Diciembre",
    }
    setNombreMes(meses[e.target.value || 1])
    setIdMes(() => parseInt(e.target.value))
  }

  useEffect(() => {
    if(tipoReporte === "1"){
      setStats([
        {
          name: "Faltas",
          stat: "F",
          bgColor: "red-500",
          comando: "Todos",
          number: 0
        },
        {
          name: "Llegadas tarde",
          stat: "T",
          bgColor: "yellow-400",
          comando: "Ausente",
          number: 0
        },
      ]);
    }else{
      setStats([
        {
          name: "Faltas",
          stat: <FaceFrownIcon className={`h-6 w-6 text-red-500`}/>,
          bgColor: "red-500",
          comando: "Todos",
          number:0
        },
        {
          name: "Llegadas tarde",
          stat: <FaceFrownIcon className={`h-6 w-6 text-yellow-400`}/>,
          bgColor: "yellow-400",
          comando: "Ausente", 
          number:0
        },
        {
          name: "Pendiente",
          stat: <FaceFrownIcon className={`h-6 w-6 text-gray-400`}/>,
          bgColor: "gray-400",
          comando: "Ausente",
          number:0
        },
      ]);
    }
    // limpiar array
    setReporteDatos([]);
    setFechaFinal("")
    setFechaInicial("")
  }, [tipoReporte])
  
  const handleFechaInicial = (e) => {
    setFechaInicial(e.target.value)
  }
  
  const handleFechaFinal = (e) => {
    setFechaFinal(e.target.value)
  }

  return (
    <>
      <WarningModal
        open={loading ? true : false}
        image={<img src="./img/loader.gif" alt="loading" />}
        opacity="bg-opacity-100"
      />
      <Transition show={true}>
        <Layout userObj={userObj} activeTab="Alumnos">
          <Container className={"w-full p-2 lg:p-8"}>
            <Header title="Asistencia" logo={DocumentCheckIcon} />
            <WarningModal
              open={modal.show ? true : false}
              image={
                modal.ok ? (
                  <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
                ) : (
                  <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
                )
              }
              title={"Aviso"}
              subtitle={<span>{modal.msg}</span>}
              opacity="bg-opacity-50"
            >
              <div className="mt-5 sm:mt-6">
                <button
                  onClick={() => {
                    if (modal.reload) {
                      window.location.reload();
                    }
                    setModal((curr) => ({
                      ...curr,
                      show: false,
                      reload: true,
                    }));
                  }}
                  type="button"
                  className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                >
                  Entendido
                </button>
              </div>
            </WarningModal>
            <WarningModal
              open={modalSeguro.show ? true : false}
              image={
                <ExclamationCircleIcon className="h-20 w-20 text-orange-400 mx-auto" />
              }
              title={modalSeguro.title}
              subtitle={<span>{modalSeguro.msg}</span>}
              opacity="bg-opacity-50"
            >
              <div className="mt-5 sm:mt-6 flex flex-row gap-4">
                
                <button
                  onClick={() => {
                    if (modal.reload) {
                      window.location.reload();
                    }
                    setModalSeguro((curr) => ({
                      ...curr,
                      show: false,
                      reload: false,
                    }));
                  }}
                  type="button"
                  className="inline-flex w-full justify-center rounded-md border border-transparent hover:border hover:border-azulBrillanteMira bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-primarioMira transition duration-500 ease focus:outline-none sm:text-sm"
                >
                  Entendido
                </button>
              </div>
            </WarningModal> 
            
            <div className="w-full  flex-col xl:flex-row flex bg-primarioMira rounded-lg ">
              <div className="basis-1/4 p-2 bg-secundarioMira m-2  rounded-lg shadow-sm shadow-white">
                  <label className="text-white font-medium mb-4 ">Datos de búsqueda</label>
                <>
                <div className="flex flex-col">
                  {tipoReporte === "1" ?
                  <div className="flex flex-col xl:flex-row gap-2 mt-1">
                      <div className="flex flex-col w-full xl:w-1/2">
                        <label className="mb-1 text-gray-100 text-sm"></label>
                        <div className="border border-gray-100 p-2 rounded">
                          <TipoVista setTipoReporte={setTipoReporte} tipoReporte={tipoReporte}/>
                        </div>
                      </div>
                      <ComboMeses handleMesChange={handleMesChange} idMes={idMes}/>
                  </div>
                  :
                  <div className="flex flex-col">
                    <div className="flex flex-col lg:w-full mt-1">
                      <label className="mb-1 text-gray-100 text-sm"></label>
                      <div className="border border-gray-100 p-2 rounded">
                        <TipoVista setTipoReporte={setTipoReporte} tipoReporte={tipoReporte}/>
                      </div>
                    </div>
                    <div className="flex flex-row gap-1 mt-1">
                      <div className="lg:w-1/2 flex flex-col">
                      <label className="text-gray-100">Fecha inicio</label>
                        <input 
                          type="date"
                          max="2099-01-01"
                          className="rounded-md my-1"
                          onChange={(e) => handleFechaInicial(e)}
                          value={fechaInicial}
                          ></input>
                      </div>
                      <div className="lg:w-1/2 flex flex-col">
                        <label className="text-gray-100">Fecha final</label>
                        <input 
                          type="date"
                          max="2099-01-01"
                          className="rounded-md my-1"
                          value={fechaFinal}
                          onChange={(e) => handleFechaFinal(e)}
                        ></input>
                      </div>
                    </div>
                  </div>
                  }
                </div>
                <div className="flex flex-col">
                  <label className="text-white text-sm ">Sede</label>
                  <select
                    id="idSede"
                    ref={sedesRef}
                    onChange={(e) => handleSede(e)}
                    name="IdSede"
                    type="select"
                    disabled={controlesBloqueados}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                  >
                    <option value="">---Selecciona Sede---</option>
                    {sedes.map((sede) => (
                      <option key={sede.IdSede} value={sede.IdSede}>
                        {sede.Sede}
                      </option>
                    ))}
                  </select>
                </div>
                <label className="text-white text-sm ">Nivel</label>
                <ComboDato
                  name={"IdNivel"}
                  textoDefault={"---Selecciona Nivel---"}
                  arr={niveles}
                  value={"IdNivel"}
                  text={"Nivel"}
                  handler={handleNivel}
                />

                <label className="text-white text-sm ">Grado</label>
                <ComboDato
                  name={"IdGrado"}
                  textoDefault={"---Selecciona Grado---"}
                  arr={grados}
                  value={"IdGrado"}
                  text={"Grado"}
                  handler={handleGrado}
                />
                <label className="text-white text-sm ">Sección</label>
                <ComboDato
                  name={"IdSeccion"}
                  textoDefault={"---Selecciona Sección---"}
                  arr={secciones}
                  value={"IdSeccion"}
                  text={"Seccion"}
                  handler={handleSeccion}
                />

                  <div className="my-2 mt-4">
                    {idSeccion && (
                      <button 
                      className="transition duration-200 hover:bg-transparent hover:border-azulBrillanteMira border p-2 bg-azulBrillanteMira text-white w-full rounded-md focus:shadow"
                      onClick={() => obtenerReporte()}>Buscar</button>
                    )}
                  </div>
                </>
                
              </div>
              <div className="basis-3/4  bg-primarioMira m-2 rounded-br-lg">
                <Transition
                  className="flex flex-col bg-secundarioMira rounded-lg shadow-sm shadow-white"
                  show={true}
                >
                  <div className="flex flex-row">
                    {stats.map(e => (
                    <p className="text-white font-medium"></p>
                    ))}
                  </div>
                  {/*
                  <Estadistica
                    stats={stats}
                    alternador={alternador}
                    indiceForzado={indiceForzado}
                    title="Actividad"
                    efectoBoton={clickeable}
                  ></Estadistica>
                  */}
                      <div className="px-2">
                       <h2 className="text-sm font-medium text-gray-500"></h2>
                       <ul role="list" className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
                         {stats.map((project) => (
                           <li key={project.name} className="col-span-1 flex rounded-md shadow-sm ">
                             <div
                               className={classNames(
                                 `bg-gray-700 flex border-gray-500 w-16 flex-shrink-0 items-center border justify-center rounded-l-md text-xl font-medium //text-white text-${project.bgColor}`,
                               )}
                             >
                               {project.stat}
                             </div>
                             <div className="flex flex-1 items-center justify-between /truncate rounded-r-md border-b border-r border-t border-gray-500 bg-secundarioMira">
                               <div className="flex-1 /truncate px-4 py-2 ">
                                 <a href={project.href} className="font-medium text-gray-100 /hover:text-gray-600">
                                   {project.name}
                                 </a>
                                 <p className="text-gray-400">{project.number}</p>
                               </div>
                             </div>
                           </li>
                         ))}
                       </ul>
                     </div>

                  {tipoReporte === "1"?
                      <div className="p-2 flex flex-col xl:flex-row gap-2">
                          <div className="block flex-row w-full xl:w-1/2 bg-primarioMira p-2 rounded-md">
                              <Calendar 
                                mes={idMes} 
                                ciclo={ciclo} 
                                nombreMes={nombreMes} 
                                data={reporteDatos} 
                                reporteDatos={reporteDatos} 
                                verModalSeguro={verModalSeguro}
                                setListaFaltas={setListaFaltas}
                                setIndiceDia={setIndiceDia}
                                indiceDia={indiceDia}
                              ></Calendar>
                           </div>
                           <div className="flex flex-row w-full xl:w-1/2 bg-primarioMira p-2 rounded-md ">
                               <section className="w-full flex flex-col">
                                   <h2 className="text-gray-100 text-xl mb-2">
                                     {`Faltas y llegadas tarde del día ${!indiceDia ? "" : indiceDia}`}
                                   </h2>
                                   <div className="text-sm text-gray-500 justify-between flex-col ">
                                     {listaFaltas.length > 0 ? listaFaltas.map((meeting, index) => (
                                       <div
                                         key={index}
                                         className={classNames(meeting[`D${indiceDia}`] === 'F' ? "bg-red-100 text-red-800 hover:bg-red-200 transition duration-500":"bg-yellow-100 text-yellow-800 hover:bg-yellow-200 transition duration-500"," flex flex-row rounded-md p-2 mb-1 justify-between elementFadeIn")}
                                       >
                                           <img src={meeting.imageUrl} alt="" className="h-10 w-10 flex-none rounded-full hidden " />

                                           <div className={"flex flex-col xl:flex-row w-full justify-around"}>
                                               <div className="flex flex-col gap-2 w-3/4">
                                                   <p className=" font-medium">{meeting.Alumno}</p>
                                                   <p className=" w-full">{meeting.Carnet}</p>
                                               </div>
                                               <div className="flex flex-row gap-2  xl:w-1/4 my-auto">
                                                   {meeting[`D${indiceDia}`] === 'F' ? 
                                                    <ExclamationCircleIcon className="h-6 w-6 text-red-500"/>
                                                   : 
                                                   <ExclamationCircleIcon className="h-6 w-6 text-yellow-500"/>
                                                   }
                                                   {/*<p className="mt-0.5">{meeting[`D${indiceDia}`]}</p>*/}
                                                  <p className="mt-0.5">{`${meeting[`D${indiceDia}`] === 'F' ? "Falta": "LLegada tarde"}`}</p>
                                               </div>
                                            </div>

                                             </div>
                                           )):
                                           <p>Seleccione el día para visualizar los datos correspondientes</p>}
                                   </div>
                                </section>
                           </div>
                             </div>
                      :
                      <div className="p-2">
                          <ResultadoDataGrid
                            Sede={idSede}
                            columnas={ columnas }
                            alumnos={reporteDatos}
                            handleAlumno={handleAlumnoCta}
                            subtitulo={subtituloTipos}
                            setModal={setModal}
                            swicht={true}
                            seleccion={true}
                          />
                      </div>
                  }
                </Transition>
              </div>
            </div>
            <></>
          </Container>
        </Layout>
      </Transition>
    </>
  );
};

export default VistaAsistenciaIndex;